import CreatePage from './CreatePage.container';
import ListPage from './ListPage.container';
import EditAndPreviewPage from './EditAndPreviewPage.container';

export default {
  CreatePage,
  ListPage,
  EditAndPreviewPage
};
